import {styled} from "@mui/material/styles"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import {Container} from "../../component"

export const StyledContainer = styled(Container)`
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY};
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};

    @media (min-width: ${breakpoints.values.md}px) {
        min-width: 6.5rem;
        height: 2.25rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        min-width: 7.75rem;
        height: 2.25rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        min-width: 7.75rem;
        height: 2.25rem;
    }
`
